import {
  currentSubscriptionOuidSelector,
  currentSubscriptionPriceSelector,
  currentSubscriptionSelector,
} from '../Dashboard/reducer';

export const lineSelector = state => currentSubscriptionSelector(state)?.line;
export const subscriptionPlanSelector = state => currentSubscriptionSelector(state)?.plan;
export const subscriptionOptionsSelector = state => currentSubscriptionSelector(state)?.options;

export const currentOfferSelector = state => ({
  plan: subscriptionPlanSelector(state),
  options: subscriptionOptionsSelector(state),
  price: currentSubscriptionPriceSelector(state),
});

export const isCurrentSubscriptionSelector = (state, subscription) => {
  const subscriptionOuid = currentSubscriptionOuidSelector(state);
  if (!subscriptionOuid && !subscription) return true;
  return !!subscription && subscriptionOuid === subscription.ouid;
};
